import { API } from "api";

export const getModelFunctionAPI = (id) => {
    return API.get(`api/modelfunction/getall?page=0&size=0&sortColumnName=PkModelFunction`)
                .then((res) => res);
};

